/**
 * PROPRIETARY AND CONFIDENTIAL
 * Copyright © 2026 Contractor Co-Pilot. All Rights Reserved.
 */

import type { OrganizationTheme } from "../../types";

export const navyBluesTheme: OrganizationTheme = {
  id: "navy-blues",
  name: "Navy Blues",
  description:
    "Professional, trustworthy palette with deep navy and sky blue accents",
  recommendedFor: [
    "Commercial Construction",
    "Large Contractors",
    "Corporate Services",
    "Engineering Firms",
  ],

  colors: {
    primary: {
      name: "Midnight Navy",
      hex: "#0B2545",
      hsl: "210 68% 16%",
      rgb: [11, 37, 69],
    },
    primaryForeground: {
      name: "White",
      hex: "#FFFFFF",
      hsl: "0 0% 100%",
      rgb: [255, 255, 255],
    },
    secondary: {
      name: "Sky Blue",
      hex: "#8DA9C4",
      hsl: "208 33% 66%",
      rgb: [141, 169, 196],
    },
    secondaryForeground: {
      name: "Midnight Navy",
      hex: "#0B2545",
      hsl: "210 68% 16%",
      rgb: [11, 37, 69],
    },
    muted: {
      name: "Light Gray",
      hex: "#F5F5F5",
      hsl: "0 0% 96%",
      rgb: [245, 245, 245],
    },
    mutedForeground: {
      name: "Medium Gray",
      hex: "#666666",
      hsl: "0 0% 40%",
      rgb: [102, 102, 102],
    },
    card: {
      name: "White",
      hex: "#FFFFFF",
      hsl: "0 0% 100%",
      rgb: [255, 255, 255],
    },
    cardForeground: {
      name: "Near Black",
      hex: "#1F1F1F",
      hsl: "0 0% 12%",
      rgb: [31, 31, 31],
    },
    background: {
      name: "White",
      hex: "#FFFFFF",
      hsl: "0 0% 100%",
      rgb: [255, 255, 255],
    },
    foreground: {
      name: "Near Black",
      hex: "#1F1F1F",
      hsl: "0 0% 12%",
      rgb: [31, 31, 31],
    },
  },

  cssVariables: {
    "--primary": "210 68% 16%",
    "--primary-foreground": "0 0% 100%",
    "--secondary": "208 33% 66%",
    "--secondary-foreground": "210 68% 16%",
    "--muted": "0 0% 96%",
    "--muted-foreground": "0 0% 40%",
    "--card": "0 0% 100%",
    "--card-foreground": "0 0% 12%",
    "--background": "0 0% 100%",
    "--foreground": "0 0% 12%",
    // Semantic colors — crisp, high-contrast alongside navy
    "--success": "150 60% 40%",
    "--success-foreground": "0 0% 98%",
    "--warning": "36 80% 50%",
    "--warning-foreground": "0 0% 12%",
    "--error": "0 75% 48%",
    "--error-foreground": "0 0% 98%",
    "--info": "200 70% 48%",
    "--info-foreground": "0 0% 98%",
    "--destructive": "0 75% 48%",
    "--destructive-foreground": "0 0% 98%",
    // Sidebar / warm surface — subtle tint of secondary hue
    "--background-warm": "208 15% 98%",
    "--background-warm-alt": "208 10% 96%",
    // Extended palette — crisp, professional accents for navy base
    "--palette-violet": "252 55% 55%",
    "--palette-teal": "175 55% 38%",
    "--palette-pink": "340 50% 52%",
    "--palette-orange": "20 80% 52%",
    "--palette-sky": "192 65% 45%",
  },
};
